import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { blogPosts, getAllTags } from '../data/blogData';
import '../styles/Blog.css';

const Blog = () => {
  const [activeTag, setActiveTag] = useState('All');
  const tags = getAllTags();

  const filtered = activeTag === 'All'
    ? blogPosts
    : blogPosts.filter(p => p.tags.includes(activeTag));

  return (
    <>
      
      <div className="blog-page">
        <div className="blog-container">

          <div className="blog-header">
            <h1 className="blog-title">Blog</h1>
            <p className="blog-subtitle">Thoughts on engineering, building, and figuring things out.</p>
          </div>

          <div className="blog-tags">
            {tags.map(tag => (
              <button
                key={tag}
                className={`blog-tag-btn ${activeTag === tag ? 'active' : ''}`}
                onClick={() => setActiveTag(tag)}
              >
                {tag}
                <span className="blog-tag-count">
                  {tag === 'All' ? blogPosts.length : blogPosts.filter(p => p.tags.includes(tag)).length}
                </span>
              </button>
            ))}
          </div>

          <div className="blog-list">
            {filtered.map(post => (
              <Link to={`/blog/${post.slug}`} key={post.slug} className="blog-card">
                <div className="blog-card-meta">
                  <div className="blog-card-tags">
                    {post.tags.map(tag => (
                      <span key={tag} className="blog-card-tag">{tag}</span>
                    ))}
                  </div>
                  <span className="blog-card-date">{post.date}</span>
                </div>
                <h2 className="blog-card-title">{post.title}</h2>
                <p className="blog-card-excerpt">{post.excerpt}</p>
                <span className="blog-card-read">Read more →</span>
              </Link>
            ))}
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog;